import { useStaticQuery, graphql } from 'gatsby'

export const queryConfig = () => {
  const query = useStaticQuery(
    graphql`
      {
        sanityConfig {
          id
          internal {
            type
            content
            contentDigest
            owner
          }
        }
      }
    `
  )
  return JSON.parse(query.sanityConfig.internal.content)
}
